import React from 'react';

import { Badge } from '@theme-ui/components';
import { Flex, Icon, Text } from '@ttoss/ui';

import { IconOpenPlantsResult, IconType } from '../Icons';

type TIcon = 'open-plants-result';

const ICONS: { [key in TIcon]: React.VoidFunctionComponent<IconType> } = {
  'open-plants-result': IconOpenPlantsResult,
};

export type BadgeButtonProps = {
  label: string;
  onClick?: () => void;
  selected?: boolean;
  icon: TIcon | string;
  'aria-label'?: string;
  iconColor?: string;
  className?: string;
};

const BadgeButton = ({
  label,
  onClick,
  selected,
  icon,
  iconColor,
  className,
  ...props
}: BadgeButtonProps) => {
  const icons = Object.keys(ICONS);

  const IconComponent = icons.includes(icon) ? ICONS[icon as TIcon] : null;

  const colors = React.useMemo(() => {
    if (selected) {
      return {
        iconColor: 'background',
        labelColor: 'background',
        backgroundColor: 'primary',
      };
    }

    return {
      iconColor: iconColor ? iconColor : 'primary',
      labelColor: 'text',
      backgroundColor: 'transparent',
    };
  }, [iconColor, selected]);

  return (
    <Flex className={className}>
      <Badge
        onClick={onClick}
        sx={{
          borderRadius: '999px',
          paddingLeft: 5,
          paddingRight: 6,
          paddingY: 4,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: colors.backgroundColor,
          borderWidth: selected ? 0 : 1,
          borderStyle: 'solid',
          borderColor: 'muted',
        }}
        {...props}
      >
        {IconComponent ? (
          <Text
            sx={{ color: selected ? 'background' : 'primary', display: 'flex' }}
          >
            <IconComponent height="21px" width="21px" />
          </Text>
        ) : (
          <Icon
            icon={icon}
            sx={{ fontSize: 3, lineHeight: 0, color: colors.iconColor }}
          />
        )}
        <Text
          sx={{
            marginLeft: 4,
            fontSize: 2,
            fontFamily: 'body',
            fontWeight: 'body',
            color: colors.labelColor,
          }}
        >
          {label}
        </Text>
      </Badge>
    </Flex>
  );
};

export default BadgeButton;
